import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import ShareBarStyle from './ShareBar.less';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import TwitterShare from './TwitterShare';
import FacebookShare from './FacebookShare';
import LinkedInShare from './LinkedInShare';

export default class ShareBarWidget extends BaseWidget {
  static propTypes = {
    /* URL to be shared */
    url: PropTypes.string.isRequired,
    /* If the widget needs to be hidden or not */
    hideWidget: PropTypes.bool,
    /* Contains the user input values to be shared */
    shareBarSettings: PropTypes.object,
    /* Widget ID */
    id: PropTypes.string,
    /* If this widget is used as a drag-droppable widget (for site-editor) or as a normal widget component */
    isDroppableWidget: PropTypes.bool,
    /* If widget is not drag-droppable, then you need to pass the styles here */
    styles: PropTypes.object,
    /**
     * Contains extra query params for the URL for individual Social Networks
     * object will contain keys for facebook, twitter and linkedIn with values in Array
     * Eg. For Facebook, the value will be, facebook: ['qParam1=value1', 'qParam2=value2']
     */
    additionalURLParams: PropTypes.object,
    /**
     * If the LinkedIn share button needs to be hidden on IE and Edge browsers.
     * Since, the LinkedIn script is causing error (on these IE & Edge) on clicking the LinkedIn button,
     * which in turns throws hard error on our site.
     */
    hideLinkedInOnIEAndEdge: PropTypes.bool
  };
  static defaultProps = {
    hideWidget: false,
    isDroppableWidget: true,
    additionalURLParams: {},
    hideLinkedInOnIEAndEdge: false
  };

  getStyleObject() {
    return {
      ...super.getStyleObject(),
      container: {
        ...super.getStyleObject().container,
        textAlign: this.getElementText('shareBarAlignment').textAlign
      },
      wrapper: this.getElementInlineStyle('wrapper')
    };
  }

  render() {
    const {
      url,
      hideWidget,
      shareBarSettings,
      isDroppableWidget,
      styles,
      additionalURLParams,
      hideLinkedInOnIEAndEdge,
      id: widgetId
    } = this.props;
    const { customizeWidgetData } = shareBarSettings;
    const Styles = isDroppableWidget ? this.getStyleObject() : styles;
    const shareBarStyles = {
      classes: ShareBarStyle,
      style: Styles
    };

    if (hideWidget) {
      return null;
    }

    return (
      <div
        {...resolve(shareBarStyles, 'container')}
        {...resolveTestId(this.props)}
      >
        { (customizeWidgetData && customizeWidgetData.displayFacebook) &&
          <FacebookShare
            shareBarStyles={shareBarStyles}
            url={url}
            additionalURLParams={additionalURLParams.facebook}
          />
        }
        { (customizeWidgetData && customizeWidgetData.displayTwitter) &&
          <TwitterShare
            shareBarStyles={shareBarStyles}
            url={url}
            additionalURLParams={additionalURLParams.twitter}
            customizeWidgetData={customizeWidgetData}
          />
        }
        { (customizeWidgetData && customizeWidgetData.displayLinkedIn) &&
          <LinkedInShare
            shareBarStyles={shareBarStyles}
            url={url}
            additionalURLParams={additionalURLParams.linkedIn}
            widgetId={widgetId}
            hideLinkedInOnIEAndEdge={hideLinkedInOnIEAndEdge}
          />
        }
      </div>
    );
  }
}
